import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BuildCommitRibbon } from './components/BuildCommitRibbon';
import reportWebVitals from './reportWebVitals';

// Backup for the public/index.html listener — webpack overlay can still catch this in some reloads.
window.addEventListener(
  'error',
  (event) => {
    const msg = event?.message ? String(event.message) : '';
    if (msg.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <BuildCommitRibbon />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
